/**
 * @file `POST /families/{familyId}/study/speech/{personId}` のクライアント。
 *
 * @what: 相手役の一言を送り、読み上げた音声を受け取る。速さは普通とゆっくりの2つである。
 * @why: 相手役の一言が文字だけだと、聞いて取る練習にならない。速さを変えられるのは、書籍に付く
 *   音声に対してこちらが持てる利点である (設計 plan/docs/study_skill_task_design.md §5.5)。
 * @failure: 読み上げが呼べないときは、使えない旨の応答が返る。呼び手は1行で知らせる。
 */

import { apiFetch } from "@/shared/api/client";

export interface StudySpeechInput {
  text: string;
  slow?: boolean;
}

export interface StudySpeechResult {
  /** 音声を符号化した文字列が入る。 */
  audio: string;
  mime: string;
  voice: string;
}

export function speakLine(
  familyId: string,
  personId: string,
  input: StudySpeechInput,
): Promise<StudySpeechResult> {
  return apiFetch<StudySpeechResult>(
    `/families/${encodeURIComponent(familyId)}/study/speech/${encodeURIComponent(personId)}`,
    { method: "POST", body: input },
  );
}

/** 受け取った音声を、その場で鳴らせる形にする。 */
export function speechAudioUrl(result: StudySpeechResult): string {
  return `data:${result.mime};base64,${result.audio}`;
}
